import { ComponentType, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import BasePage from "../components/test_controller/dashboard/BasePage";
import ChangePassword from "@components/change_password/ChangePassword";
import NotFoundPage from "@components/common/NotFoundPage";
import { isLoggedIn } from "../utils/CommonUtil";
import { selectUserForcePassChange } from "@utils/redux-utils/selectors/userSelectors";
import { setPostLoginRedirect } from "@utils/auth";
import { useAuthContext } from "@service";
import { useSelector } from "react-redux";

interface PrivateRouteProps {
  component: ComponentType<any>;
  allowedScopes?: string[];
}

function PrivateRoute({ component: Component, allowedScopes, ...rest }: PrivateRouteProps) {
  const [authChecked, setAuthChecked] = useState(false);
  const [isLogged, setIsLogged] = useState(false);
  const forcePasswordChange = useSelector(selectUserForcePassChange);

  const { scopes, scopesLoaded } = useAuthContext();
  const { pathname, search, hash } = useLocation();
  const requestedPath = `${pathname}${search}${hash}`;

  useEffect(() => {
    const result = isLoggedIn();

    if (!result) {
      setPostLoginRedirect(requestedPath);
    }
    setIsLogged(result);
    setAuthChecked(true);
  }, [requestedPath]);

  if (!authChecked) return null; // or show loading spinner

  if (!isLogged) {
    return <Navigate to="/login" replace state={{ from: requestedPath }} />;
  }

  if (allowedScopes?.length) {
    if (!scopesLoaded) return null;
    if (!allowedScopes.some((scope) => scopes.includes(scope))) {
      return <NotFoundPage variant="noAccess" />;
    }
  }

  return forcePasswordChange ? (
    <BasePage component={<ChangePassword />} />
  ) : (
    <BasePage component={<Component {...rest} />} />
  );
}

export default PrivateRoute;
